import React from "react";
import { Box, Button, Typography } from "@mui/material";
import { useNavigate } from "react-router-dom";

const LoginInfo = () => {
  const navigate = useNavigate();

  return (
    <Box sx={{ maxWidth: "400px", width: "100%", mx: "auto", textAlign: "center", mt: 13 }}>
      <Typography variant="h4" fontWeight={700} gutterBottom>
        Cory Hixson Tutoring
      </Typography>
      <Typography variant="body1" color="text.secondary" mb={3}>
        Targeted SAT & ACT practice with Cory's guidance
      </Typography>
      <Button
        variant="contained"
        onClick={() => navigate("/signup")}
        sx={{
          borderRadius: "25px",
          py: 1.25,
          px: 3,
          textTransform: "none",
          fontWeight: 600,
        }}
      >
        Create Account
      </Button>
    </Box>
  );
};

export default LoginInfo;
